import { debounce } from './debounce';
import { validator } from './regex';
import { getParamFromUrl } from './utils';

export const inputHandler = (inputWrapper, cb) => {

  if (!inputWrapper) return;

  const input = inputWrapper.querySelector('input');

  if (!input) return;

  if (input.hasAttribute('disabled')) return;
  const errorMsg = inputWrapper.querySelector('[data-error]');
  const dataSearchButton = inputWrapper.querySelector('[data-search-button]');
  const luhnAlgo = input.hasAttribute('data-luhn-algo');
  const isPhoneNumber = input.hasAttribute('data-phone');
  const isNumericOnly = input.hasAttribute('data-numeric');

  const isRequired = input.getAttribute('required') === 'true';

  const cleanUp = ({ cleanUpCbFn = null }) => {
    input.classList.remove('input_error');
    input.value = '';
    cb?.(input.value);
    cleanUpCbFn?.(input.value);

    if (dataSearchButton) searchIconHandler(input.value, dataSearchButton);
  };

  const onInput = (value) => {

    if (isRequired && errorMsg) {
      const isValid = validator(value, input.type, luhnAlgo, isPhoneNumber);
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (isPhoneNumber) {
      const isValid = isRequired || value.length > 0 ? validator(value, input.type, false, isPhoneNumber) : true;
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (!isRequired && input.type === 'number') {
      const isValid = value.length > 0 ? validator(value, input.type, luhnAlgo, isPhoneNumber) : true;
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (!isRequired && input.type === 'email' && input.value.length > 0 && errorMsg) {
      const isValid = validator(value, input.type);
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (dataSearchButton) searchIconHandler(input.value, dataSearchButton);
    cb?.(value);
  };

  const onLoad = (value) => {
    if (isRequired && errorMsg && value) {
      const isValid = validator(value, input.type, luhnAlgo, isPhoneNumber);
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (isPhoneNumber && value) {
      const isValid = isRequired || value.length > 0 ? validator(value, input.type, false, isPhoneNumber) : true;
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (!isRequired && input.type === 'email' && input.value.length > 0) {
      const isValid = validator(value, input.type);
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (!isRequired && input.type === 'number') {
      const isValid = value.length > 0 ? validator(value, input.type, luhnAlgo, isPhoneNumber) : true;
      isValid ? input.classList.remove('input_error') : input.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    if (dataSearchButton) searchIconHandler(input.value, dataSearchButton);
    cb?.(value);
  };

  if (isNumericOnly) {
    input.addEventListener('keydown', (e) => {
      if (
        !e.key.match(/^\d$/) && // Allow only digits 0-9
        !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
      ) {
        e.preventDefault();
      }
    });

    input.addEventListener('beforeinput', (e) => {
      if (e.data && !e.data.match(/^\d$/)) {
        e.preventDefault();
      }
    });
  }

  input.addEventListener('input', debounce((e) => {

    if (e.isComposing) return;
    input.classList.remove('input_error');
    if (isNumericOnly) input.value = input.value.replace(/\D/g, '');
    if (errorMsg && isRequired) errorMsg.classList.add('hidden');
    if (!isRequired && input.type === 'email') errorMsg.classList.add('hidden');
    if (dataSearchButton) searchIconHandler(input.value, dataSearchButton);
  }), 500);

  input.addEventListener('keyup', debounce((e) => {
    if (e.isComposing) return;
    onInput(e.target.value);
  }, 500));

  if (dataSearchButton) {
    dataSearchButton.addEventListener('click', cleanUp);

    dataSearchButton.addEventListener('keydown', (e) => {
      if (e.key === 'ENTER' || e.key === '') {
        cleanUp();
      }
    });
  }
  if (getParamFromUrl(input.id)) {
    input.value = getParamFromUrl(input?.id).length > 0 ? getParamFromUrl(input?.id) : input.value;
  }
  onLoad(input.value);
  return cleanUp;
};

export const searchIconHandler = (value, searchButton) => {

  if (!searchButton) return;

  const searchButtonClasses = searchButton.classList;

  if (value?.length) {
    searchButtonClasses.remove('icon-dsk-search');
    searchButtonClasses.add('icon-close');
    return;
  }
  searchButtonClasses.add('icon-dsk-search');
  searchButtonClasses.remove('icon-close');
};
